import { gql } from "graphql-request";

const SERVER_UPDATE_COMPANY = gql`
  mutation SERVER_UpdateCompany($id: ID!, $input: CompanyInput!) {
  updateCompany(id: $id, input: $input) {
    id
    __typename
  }
}
`;
export default SERVER_UPDATE_COMPANY;
